import Axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { useAuth } from 'react-oidc-context';

export const AXIOS_INSTANCE = Axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
});

export const useCustomAxios = <T>() => {
    const auth = useAuth();
    const auth_url = process.env.REACT_APP_AUTH_AUTHORITY;
    const client_id = process.env.REACT_APP_AUTH_CLIENT_ID;

    const customAxios = async (config: AxiosRequestConfig): Promise<T> => {
        // Use ID token for authentication (contains user identity with client_id as audience)
        let idToken: any = auth.user?.id_token;
        if (!idToken) {
            const key = `oidc.user:${auth_url}:${client_id}`;
            const user: any = sessionStorage[key];
            idToken = JSON.parse(user)['id_token'];
        }
        const { data } = await AXIOS_INSTANCE({
            ...config,
            headers: {
                ...config.headers,
                Authorization: `Bearer ${idToken}`,
                'Content-Type': 'application/json',
            },
        });
        return data;
    };
    return customAxios;
};

export type ErrorType<Error> = AxiosError<Error>;
